<div class="cbc-tl">
  <div class="cbc-tl-interactions">
    <div *ngIf="item && item.cells" class="cbc-tl-letter-display-text"
         matTooltip="{{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}">
      {{this.item?.cells[this.fieldDefinition.key]?.displayText ? this.item?.cells[this.fieldDefinition.key]?.displayText : ''}}
    </div>
    <div class="cbc-interactions flex flex-row">
      <button class="cbc-tl-letter-generation-button"
              *ngIf="item.cells[fieldDefinition.key].value"
              (click)="generateTL()">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             preserveAspectRatio="xMidYMid" width="17" height="20" viewBox="0 0 17 20">
          <image
            xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAMAAABcfiZ7AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAeFBMVEUAAAA0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQAAACIn0ihAAAAJnRSTlMAuOErpXNx/m9tebu6MfgY893xEWWxIvL6qhRQyPAeeBDD2+fTtK5kSikAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAbklEQVQY063PyRaCMAyF4TAWLQg4UhAZve//iMYeetCw5V9+m5uQhyWfArJhlTDaCOKNqEQK1OFPjlrrNFvllJPYQlHafmSJ5Xz5dr3dH04qY+rGPENqnXCvDthPel50MozAxD/o2Ym4UIon4P0BrQYmoVTNcIEAAAAASUVORK5CYII="
            width="17" height="20"/>
        </svg>
      </button>
    </div>
  </div>
</div>


